import { cn } from '@lair-finance/util'
import { AssetItem } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/AssetItem.tsx'
import { TokenAddresses } from '@/shared/config/token.ts'
import { useTokenBalance } from '@/shared/lib/wagmi/hooks/useTokenBalance.ts'
import { ActiveChain } from '@/domains/chain'
import { formatAssetAmount } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/lib/formatAssetAmount.ts'

export function WalletAssetListKaia({ className }: { className?: string }) {
  const chainId = ActiveChain.KAIA.id
  const { balance: balanceKAIA = '0' } = useTokenBalance({ chainId, watch: true })
  const { balance: balanceLAIR = '0' } = useTokenBalance({ chainId, tokenAddress: TokenAddresses[chainId].LAIR, watch: true })
  const { balance: balanceStKAIA = '0' } = useTokenBalance({
    chainId,
    tokenAddress: TokenAddresses[chainId].stKAIA,
    watch: true,
  })
  const { balance: balanceRstKAIA = '0' } = useTokenBalance({
    chainId,
    tokenAddress: TokenAddresses[chainId].rstKAIA,
    watch: true,
  })

  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <AssetItem ticker={'LAIR'} amount={formatAssetAmount(balanceLAIR)} />
      <AssetItem ticker={'KAIA'} amount={formatAssetAmount(balanceKAIA)} />
      <AssetItem ticker={'stKAIA'} amount={formatAssetAmount(balanceStKAIA)} />
      <AssetItem ticker={'rstKAIA'} amount={formatAssetAmount(balanceRstKAIA)} />
    </div>
  )
}
